@use "@design/design-tokens/typography/typography" as *;
@use "@design/design-tokens/border-radius/border-radius" as *;

.root {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}

.flexRowWrapper {
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 4px;
}

.companyNameContainer {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-left: 8px;
  font-family: var(--font-nort);
  @include typography-v2-body-sm;
  max-width: 160px;
}

.tag {
  @include typography-v2-body-sm;
  color: var(--text-soft);
  text-transform: uppercase;
}

.iconContainer {
  position: absolute;
  top: -4px;
  right: -4px;
}

.iconsContainer {
  position: relative;
}

.styledIcon {
  background-color: var(--background-soft);
  @include border-radius-full;
  width: 16px;
  height: 16px;
}

.styledTextNa {
  @include typography-v2-ui-xs;
  color: var(--text-disabled);
  font-family: var(--font-nort);
  display: flex;
  justify-content: center;
}

.titleLabel {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
